import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	narratorAriaLabel: {
		id: 'app.narrator.narratorAriaLabel',
		defaultMessage: "View {name}'s page",
		description: 'Screen reader label for the program narrator attribution link',
	},
});
